#!/usr/bin/env node
import 'dotenv/config.js';
import _yargs from 'yargs';
import { hideBin } from 'yargs/helpers';
import { staticOptions } from './helpers/config.js';
import { setTheme, themed } from './helpers/print.js';
import 'aws-sdk';
import { commands } from './commands/index.js';
process.env.AWS_SDK_JS_SUPPRESS_MAINTENANCE_MODE_MESSAGE = '1';
// set theme once here
const myTheme = {};
setTheme(myTheme);

const yargs = _yargs(process.argv.slice(2));

yargs
  .usage(themed('Usage: $0 <command>'))
  .command(commands)
  .demandCommand()
  // .help()
  // .version('v')
  .alias('v', 'version')
  .alias('h', 'help')
  .string('_')
  .strictCommands()
  // .strictOptions()
  .epilogue(themed('For more information, visit https://docs.hotglue.xyz/docs/cli-overview'))
  .wrap(Math.min(yargs.terminalWidth(), 90))
  .parse(hideBin(process.argv), staticOptions);
// .parse(hideBin(process.argv));

export {};
